import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import * as FxLog from '../../fx/FxLog';
import GxList from '../../gx/GxList';
import { useWindowSize } from '../../hx/useWindowSize';
import * as FxTable from '../../fx/FxTable';
import { isApp } from '../../gx/GxStore';
import CxIconButton from '../../cx/CxIconButton';
import * as FxFetch from '../../fx/FxFetch';


const MxSettClientRestoreList = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();

  const r_list = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const restoreItem = (row) => {
    let record = {};
    record['idValue'] = row.inClient;
    Promise.all([FxFetch.doJsonX('sett/client/restore/do', record)]).then((result) => {
      if (result[0].theValue==='OK') {
        r_list.current.refresh();
      }
    });
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inClient", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '30%', cursor: 'notallowed' });
        cols.push({ id: id++, Header: trans('field.ic'), accessor:"txIc", highlight: true, width: '15%', cursor: 'notallowed' });

        if ((isApp('vett') || isApp('spaw'))) {
          cols.push({id: id++, Header: trans('field.patient'), accessor: "animal_txAnimal", highlight: true, width: '15%', cursor: 'notallowed' });
          cols.push({ id: id++, Header: trans('field.species'), accessor: "animal_txTypeAnimalSpecies", width: '15%', cursor: 'notallowed' });
          cols.push({ id: id++, Header: trans('field.breed'), accessor: "animal_txTypeAnimalBreed", width: '15%', cursor: 'notallowed' });
        } else {
          cols.push({ id: id++, Header: trans('field.code'), accessor: "txCode", highlight: true, width: '15%', cursor: 'notallowed' });
          //cols.push({ id: id++, Header: trans('field.from'), accessor: row => ( FxTable.cellToLocalDate(row["dtFrom"]) ), width: '15%', cursor: 'notallowed' });
          cols.push({ id: id++, Header: trans('field.email'), accessor: "txEmail", width: '15%', cursor: 'notallowed' });
          cols.push({ id: id++, Header: trans('field.phone1'), accessor: "txPhone1", width: '15%', cursor: 'notallowed' });
        }
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '15%', cursor: 'notallowed' });
        cols.push({ id: id++, Header: trans('field.balance'), accessor: row => FxTable.cellTo2r00(row["theBalance"]), width: '10%', align: 'right', cursor: 'notallowed' });
        cols.push({ id: id++, accessor: row => { return <CxIconButton type="restore" classType="ibs_iconbutton_table" data={row} onClick={restoreItem} tooltip={trans('field.restore')} />}, align: 'center', width: '5%' });

      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '70%' });
        if ((isApp('vett') || isApp('spaw'))) {
          cols.push({id: id++, Header: trans('field.patient'), accessor: "animal_txAnimal", highlight: true, width: '30%'});
        } else {
          cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
        }
        cols.push({ id: id++, accessor: row => { return <CxIconButton type="restore" classType="ibs_iconbutton_table" data={row} onClick={restoreItem} tooltip={trans('field.restore')} />}, align: 'center', width: '10%' });
      }

    } catch(error) {
      FxLog.errorx('MxSettClientRestoreList.getTableColumns', error)
    }
    return cols;
  }

  return (
    <div>
      <GxList
        moduleName={trans('field.deactivated_x').replace('%s',trans('field.clients'))}
        xref={r_list}
        tooltip={`${trans('field.client')}${(isApp('vett') || isApp('spaw')) ? ' / ' + trans('field.patient') : ' / ' + trans('field.code')}`}
        fullscreen
        url="sett/client/restore"
        columns={getTableColumns()}
        hasButtonAdd={false}
      />

    </div>

  );

}

export default MxSettClientRestoreList;
